import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/RhytName/editor/rhytnameeditor.tsx",
    () => import("./rhytnameeditor"),
);
